import React from 'react'
import Color from 'constants/colors'
import styled from 'styled-components'


const AbsoluteOverBleed = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`;

const AbsoluteUnderBleed = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`;

const Relative = styled.div`
	position: relative;
	min-height: 206px;
`;

const Wallpaper = styled.div`
	background-image: url('${props=>props.img}');
	background-repeat: space;
	height: 206px;
	width: 100%;
	background-size: contain;
`;

const IntroImage = (props) => {
	const {color, img} = props;
	return(
		<Relative>
			<AbsoluteOverBleed>
				<Banner color={`${Color(color)}`}/>
			</AbsoluteOverBleed>
			<AbsoluteUnderBleed>
				<Wallpaper img={img}/>
			</AbsoluteUnderBleed>
		</Relative>
	);
}

const Banner = (props) => (
	<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><path d="M0 42.93L1400 .07v160.04L0 205.07z" fill={props.color} fillRule="evenodd"/></svg>
)


export default IntroImage;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/IntroImage.js